import { eCardBrand } from '../../SubscriptionManager.enums';
import { tCardBrandProps } from '../../SubscriptionManager.types';
import { ReactElement } from 'react';
import AmericanExpressIcon from '../../../../../../assets/americanExpressIcon.svg';
import VisaIcon from '../../../../../../assets/visaIcon.svg';
import MasterCardIcon from '../../../../../../assets/masterCardIcon.svg';
import CreditCardIcon from '../../../../../../assets/creditCardIcon.svg';

export default function CardBrand({ brand }: tCardBrandProps): ReactElement {
  switch (brand) {
    case eCardBrand.VISA:
      return <VisaIcon />;
    case eCardBrand.MASTERCARD:
      return <MasterCardIcon />;
    case eCardBrand.AMERICAN_EXPRESS:
      return <AmericanExpressIcon />;
    default:
      return <CreditCardIcon />;
  }
}
